import template from './address-validation.html';

export const radio = ({id, label, value }) => {
    return `
        <div class="address-validation__field">
            <input
                class="address-validation__radio "
                type="radio"
                name="SuggestedAddress"
                id="${id}"
                value="${value}"
                required
                data-control="radio" />

            <label for="${id}">
                ${label}
            </label>
        </div>
    `;
};

export default template;
